import React, { FC, ReactNode } from 'react';
import { Modal } from '@/components/ui';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import { Image } from '@/components/ui/Image';
import { TypeModalFields } from '@/core/generated-types';

interface SubscriberShopModalWrapperProps extends TypeModalFields {
  isOpen: boolean;
  handleClose: () => void;
  isCloseable?: boolean;
  ctaButtons: ReactNode;
}

const SubscriberShopModalWrapper: FC<SubscriberShopModalWrapperProps> = ({
  isOpen,
  handleClose,
  isCloseable = true,
  title,
  decorativeImage,
  description,
  ctaButtons,
}) => {
  return (
    <Modal isOpen={isOpen} handleClose={handleClose} isCloseable={isCloseable}>
      <div className="container lg:w-[936px] lg:pt-6">
        <div className="mx-auto max-w-[700px] text-center">
          <Heading
            text={title}
            tag={HeadingTag.H3}
            size={HeadingSize.H3}
            classes="mb-6"
          />
          {decorativeImage && (
            <Image
              imageData={decorativeImage}
              alt={decorativeImage?.fields.altText}
              className="m-auto mb-6 h-[5px] w-[71px] md:h-[13px] md:w-[121px]"
              width={121}
              height={13}
            />
          )}
          <p className="mb-6">{description}</p>
          <div className="flex flex-col items-center">{ctaButtons}</div>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(SubscriberShopModalWrapper);
